module.exports = __webpack_public_path__ + "media/index/map-8bb70689.svg";